// SVG vocabulary shared with the approved macOS mockups.
export function MacIcon({ name, size = 17 }: { name: string; size?: number }) {
  const paths: Record<string, any> = {
    sun: (
      <>
        <circle cx="12" cy="12" r="4" />
        <path d="M12 2v2m0 16v2M2 12h2m16 0h2M5 5l1.5 1.5m11 11L19 19M5 19l1.5-1.5m11-11L19 5" />
      </>
    ),
    moon: <path d="M20.5 14A9 9 0 0 1 10 3.5 9 9 0 1 0 20.5 14Z" />,
    undo: <path d="M3 7h10a7 7 0 0 1 0 14M3 7l5-5M3 7l5 5" />,
    redo: <path d="M21 7H11a7 7 0 0 0 0 14M21 7l-5-5M21 7l-5 5" />,
    import: (
      <>
        <path d="M12 3v12m-4-4 4 4 4-4M4 14v7h16v-7" />
      </>
    ),
    edit: (
      <>
        <path d="m4 16-1 5 5-1L20 8l-4-4Z M14 6l4 4" />
      </>
    ),
    delete: (
      <>
        <path d="M4 6h16M9 6V3h6v3M6 6l1 15h10l1-15M10 10v7m4-7v7" />
      </>
    ),
    print: (
      <>
        <path d="M7 8V3h10v5M7 17H3V8h18v9h-4M7 14h10v7H7Z" />
      </>
    ),
    grid: (
      <>
        <rect x="3" y="3" width="7" height="7" rx="1.5" />
        <rect x="14" y="3" width="7" height="7" rx="1.5" />
        <rect x="3" y="14" width="7" height="7" rx="1.5" />
        <rect x="14" y="14" width="7" height="7" rx="1.5" />
      </>
    ),
    users: (
      <>
        <circle cx="9" cy="8" r="3" />
        <path d="M3 20v-2a6 6 0 0 1 12 0v2M16 5a3 3 0 0 1 0 6M18 14a5 5 0 0 1 3 5" />
      </>
    ),
    calendar: (
      <>
        <rect x="3" y="5" width="18" height="16" rx="3" />
        <path d="M7 3v4m10-4v4M3 11h18M7 15h2m4 0h2m-8 3h2" />
      </>
    ),
    live: (
      <>
        <circle cx="12" cy="12" r="3" />
        <path d="M5.6 5.6a9 9 0 0 0 0 12.8m12.8 0a9 9 0 0 0 0-12.8M8 8a5.6 5.6 0 0 0 0 8m8 0a5.6 5.6 0 0 0 0-8" />
      </>
    ),
    "referee-lights": (
      <>
        <rect x="2" y="6" width="20" height="12" rx="3" />
        <circle cx="6" cy="12" r="2.25" />
        <circle cx="12" cy="12" r="2.25" />
        <circle cx="18" cy="12" r="2.25" />
      </>
    ),
    "broadcast-widget": (
      <>
        <rect x="2" y="3" width="20" height="15" rx="2" />
        <rect x="5" y="11" width="14" height="4" rx="1" />
        <path d="M8 22h8m-4-4v4" />
      </>
    ),
    monitor: (
      <>
        <rect x="3" y="3" width="18" height="14" rx="2" />
        <path d="M8 21h8m-4-4v4" />
      </>
    ),
    search: (
      <>
        <circle cx="10.5" cy="10.5" r="6.5" />
        <path d="m16 16 5 5" />
      </>
    ),
    chevron: <path d="m9 5 7 7-7 7" />,
    down: <path d="m6 9 6 6 6-6" />,
    settings: (
      <>
        <path d="M4 7h16M4 17h16" />
        <circle cx="8" cy="7" r="2" />
        <circle cx="16" cy="17" r="2" />
      </>
    ),
    check: <path d="m5 12 4 4L19 6" />,
    close: <path d="m6 6 12 12M6 18 18 6" />,
    plus: <path d="M12 4v16M4 12h16" />,
    arrow: <path d="M4 12h16m-6-6 6 6-6 6" />,
    back: <path d="M20 12H4m6-6-6 6 6 6" />,
    play: <path d="m8 4 12 8-12 8Z" />,
    pause: <path d="M8 5v14m8-14v14" />,
    clock: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v5l3 2" />
      </>
    ),
    cloud: (
      <path d="M6 18a5 5 0 1 1 1-9 6 6 0 0 1 11-1 5 5 0 0 1 0 10M9 14l3 3 4-4" />
    ),
    folder: <path d="M3 7V5h6l3 3h9v12H3Z" />,
    layers: (
      <>
        <path d="m12 3 10 5-10 5L2 8Zm-9 10 9 5 9-5M3 18l9 5 9-5" />
      </>
    ),
    text: <path d="M4 6V3h16v3M12 3v18m-4 0h8" />,
    shape: <rect x="4" y="4" width="16" height="16" rx="2" />,
    pointer: <path d="m5 3 14 11-7 1-3 7Z" />,
    eye: (
      <>
        <path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12Z" />
        <circle cx="12" cy="12" r="3" />
      </>
    ),
    export: (
      <>
        <path d="M12 15V3m-4 4 4-4 4 4M4 12v9h16v-9" />
      </>
    ),
    bar: (
      <>
        <path d="M2 12h20M5 7v10m3-13v16m8-16v16m3-13v10" />
      </>
    ),
    inspector: (
      <>
        <rect x="3" y="4" width="18" height="16" rx="2" />
        <path d="M15 4v16m3-11h1m-1 4h1" />
      </>
    ),
    more: (
      <>
        <circle cx="5" cy="12" r="1" />
        <circle cx="12" cy="12" r="1" />
        <circle cx="19" cy="12" r="1" />
      </>
    ),
    link: (
      <>
        <path d="m10 14 4-4m-5-3 2-2a5 5 0 0 1 7 7l-2 2M8 10l-2 2a5 5 0 0 0 7 7l2-2" />
      </>
    ),
    reset: (
      <>
        <path d="M4 10a8 8 0 1 1 1 8M4 4v6h6" />
      </>
    ),
  };
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.55"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {paths[name] || paths.grid}
    </svg>
  );
}
